import { useRMSelector } from 'redux/hooks';

export const useGetBackgroundJobs = () => {
  return useRMSelector((state) => state.backgroundJobs.backgroundJobs);
};
